module.exports = __webpack_public_path__ + "static/media/dairygold.46a112fe.png";